/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Who competes: teams of organizations, or individual users in teams.
 * @export
 */
export const EventParticipation = {
    Organizations: 'organizations',
    Users: 'users'
} as const;
export type EventParticipation = typeof EventParticipation[keyof typeof EventParticipation];


export function instanceOfEventParticipation(value: any): boolean {
    for (const key in EventParticipation) {
        if (Object.prototype.hasOwnProperty.call(EventParticipation, key)) {
            if (EventParticipation[key as keyof typeof EventParticipation] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EventParticipationFromJSON(json: any): EventParticipation {
    return EventParticipationFromJSONTyped(json, false);
}

export function EventParticipationFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventParticipation {
    return json as EventParticipation;
}

export function EventParticipationToJSON(value?: EventParticipation | null): any {
    return value as any;
}

export function EventParticipationToJSONTyped(value: any, ignoreDiscriminator: boolean): EventParticipation {
    return value as EventParticipation;
}

